import {createSlice} from '@reduxjs/toolkit';

const videoSlice = createSlice({
  name: 'video',
  initialState: {
    url: '',
    urls: []
  },
  reducers: {
    setUrl: (state, action) => {
      state.url = action.payload;
    },
    setUrls: (state, action) => {
      state.urls = action.payload;
    },
    addUrl: (state, action) => {
      state.urls.unshift(action.payload);
    },
    updateOrAddUrl: (state, action) => {
      const index = state.urls.findIndex(url => url.url === action.payload.url);

      if (index !== -1) {
        state.urls.splice(index, 1);
      }

      state.urls.unshift(action.payload);
    },
    updateInPlace(state, action) {
      const index = state.urls.findIndex(url => url.url === action.payload.url);

      if (index !== -1) {
        state.urls[index] = action.payload;
      }
    }
  }
});

export const {setUrl, setUrls, addUrl, updateOrAddUrl, updateInPlace} = videoSlice.actions;
export default videoSlice.reducer;
